<div class="chart-widget">
  <canvas  id="MyChart" >{{ chart }}</canvas>
</div>